<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <div class="body">
            <slot />
          </div>
          <input
            class="mystory_close_mark"
            type="image"
            :src="
              mediaportalResourceUrl +
              '/community/img/btn_close_brown_circle1@3x.png'
            "
            @click.self="$emit('close')"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  computed: {
    mediaportalResourceUrl: function () {
      return (
        process.env.VUE_APP_BASE_MEDIAPORTAL_URL +
        process.env.VUE_APP_MEDIAPORTAL_RESOURCE_URI
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 500;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    /* overflow: hidden; */
  }

  &-content {
    height: 20rem;
    width: 18rem;
    background-color: #F4DED4;
    padding: 10px 20px;
    .mystory_close_mark{
        position: absolute;
        right: -5%;
        top: -5%;
        z-index: 600;
        height: 50px;
        width: 50px;
    }
    .body{
      width: 90%;
      margin-right: auto;
      margin-left: auto;
      margin-top: 2.5vh;
      margin-bottom: 2.5vh;
      border-radius: 12px;
      background-color: #F3E7D8;
      text-align: center;
      height: 80vh;
    }
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

// オーバーレイのトランジション
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LogoutModal.vue